module.exports = __webpack_public_path__ + "img/wf-finishing-position-18.bb900bff.svg";